/**
 * Action : Mixpanel Script Init
 */



document.addEventListener('bliss:mixpanel:activate',function() {
  const category_path = {
    '/pages/activewear' : 'Shop All',
    '/collections/bottomwear-filter' : 'Bottomwear',
    '/collections/jackets-hoodies-1' : 'Jackets Hoodies',
    '/collections/tops-and-tshirts-filter' : 'Topwear',
    '/collections/sports-bras-filter' : 'Sports Bra',
    '/collections/accessories-filter' : 'Accessories'
  };
  
  // Update Mixpanel Props
  setMixpanelProps();

  /**
   * Action : Item Detail Page Viewed And Color Swatch Clicked Events
   * Event : Product Page Events
   */
  // if (window.location.href.indexOf("/products/") > -1) {
  //   const productName = jQuery('.product-info .product-info__title').text();
  //   let productPrice = jQuery('.product-info__price sale-price > .money').text();
  //   productPrice = parseFloat(productPrice.replace(/Rs\. |,/g, ''));
    
  //   mixpanel.track('Item Detail Page Viewed', {
  //       'Product Name': productName,
  //       'Section': 'Product Detail',
  //       'Prodcut Price': productPrice
  //   });
  // }

  /**
   * Action : Cart page & Cart drawer Cart item removed
   * Event : Cart Item Removed
   */
  document.addEventListener('remove:cart:item', function(event) {
    let lineKey = event.detail.key;
    let cartContent = (async function() {
      const response = await fetch(`${Shopify.routes.root}cart.js`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
      const cartData = await response.json();
      // console.log(cartData.items);
      const removeline = cartData.items.filter((lineItem2) => lineItem2["key"] === lineKey);
      if(removeline.length > 0){
        mixpanel.track('Cart Item Removed', {
          'Product Name': removeline[0].product_title,
          'Product Section': 'Cart Detail',
          'Prodcut Price': (removeline[0].line_price/100),
          'Product Variant Title': removeline[0].variant_title,
          'Product Variant Id': removeline[0].variant_id,
          'Product Variant Quantity': removeline[0].quantity
        });
      }
    })();
  });

  /**
   * Action : Collection Page View Event
   * Event : Collection Page Viewed
   */
  // if (window.location.href.indexOf("/collections/") > -1) {
  //   mixpanel.track('Collection Page Viewed', {
  //       'Collection Name': mixpanel_customer_data['collection_title'],
  //       'Section': 'Collection Detail'
  //   });
  // }


  
   /**
   * Action : Sort Clicked
   * Event : Sort Clicked
   */
    jQuery('facet-sort-by button[role="option"], [name="sort_by"]~label').click(function(){
      mixpanel.track('Sort Clicked', {
        'Section': 'Sort Clicked',
        'Sorted Value' : jQuery(this).text(),
      });
    });

  /**
   * Action : Sort Clicked
   * Event : Sort Clicked
   */
    jQuery('.facets-vertical [type="checkbox"]~label:not([name="sort_by"]~label)').click(function(){
      mixpanel.track('Filter Clicked', {
        'Section': 'Filter Clicked',
        'Sorted Value' : jQuery(this).text(),
      });
    });

  /**
   * Action : Hamburger menu clicked
   * Event : Hamburger menu clicked
   */
    jQuery('[aria-controls="header-sidebar-menu"]').click(function(){
      mixpanel.track('Hamburger menu clicked', {
        'Section': 'Hamburger menu clicked',
      });
    });
  
  /**
   * Action : Hamburger Main menu banner clicked
   * Event : Hamburger Main menu banner clicked
   */
    jQuery('.mobile-menu-image a').click(function(){
      mixpanel.track('Hamburger Main menu banner clicked', {
        'Section': 'Hamburger Main menu banner clicked',
      });
    });

  /**
   * Action : Hamburger App download click
   * Event : Hamburger App download click
   */
    jQuery('.download-app .sidebar-app-logo').click(function(){
      mixpanel.track('Hamburger App download click', {
        'Section': 'Hamburger App download click',
        'App Link': jQuery(this).attr('href'),
      });
    });

  
  /**
   * Action : B2B Navigation click
   * Event : B2B Navigation click
   */
    jQuery('.product-category-slider .collection-link').click(function(){
      mixpanel.track('B2B Navigation click', {
        'Section': 'B2B Navigation click',
        'Product Name': jQuery(this).find('.collection-subtext').text(),
        'Product Link': jQuery(this).attr('href'),
      });
    });

  if (window.location.href.indexOf("/account/register") > -1) {
    localStorage.setItem('landing_page', 'register');
  }else if(window.location.href.indexOf("/account/login") > -1){
    localStorage.setItem('landing_page', 'login');
  }
  
    /**
   * Action : Customer Sign Up Started Event
   * Event : Sign Up Started
   */
    jQuery(document).on('click', '[href="/account/register"]', function() {
      mixpanel.track('Sign Up Started', {
          'Section': 'Sign Up Started'
      });
    });

    /**
   * Action : Customer Login Completed Event
   * Event : Login Completed
   */
    if (window.location.href.indexOf("/account") > -1 && window.location.href.indexOf("/account/") == -1 && localStorage.getItem('landing_page') == 'login') {
      let loggedIn_check = localStorage.getItem('loggedIn');
      if(loggedIn_check == undefined || loggedIn_check == null || loggedIn_check == ''){
        // console.log('Login Completed');
        mixpanel.track('Login Completed', {
            'Section': 'Login Completed',
            "Customer Id": mixpanel_customer_data.id || null,
            "Customer Name": mixpanel_customer_data.name || null,
            "Customer Email": mixpanel_customer_data.email || null,
            "Customer Phone": mixpanel_customer_data.phone || null,
            "Customer Orders Count": mixpanel_customer_data.orders_count || null,
            "Customer First Name": mixpanel_customer_data.first_name || null,
            "Customer Last Name": mixpanel_customer_data.last_name || null
        });
        localStorage.setItem('loggedIn', 'true');
      }
    }else if(window.location.href.indexOf("/account") > -1 && window.location.href.indexOf("/account/") == -1 && localStorage.getItem('landing_page') == 'register'){
      let account_check = localStorage.getItem('account_creation');
      if(account_check == undefined || account_check == null || account_check == ''){
        // console.log('Sign Up Completed');
        mixpanel.track('Sign Up Completed', {
            'Section': 'Sign Up Completed',
            "Customer Id": mixpanel_customer_data.id || null,
            "Customer Name": mixpanel_customer_data.name || null,
            "Customer Email": mixpanel_customer_data.email || null,
            "Customer Phone": mixpanel_customer_data.phone || null,
            "Customer Orders Count": mixpanel_customer_data.orders_count || null,
            "Customer First Name": mixpanel_customer_data.first_name || null,
            "Customer Last Name": mixpanel_customer_data.last_name || null
        });
        localStorage.setItem('account_creation', 'true');
      }
    }

    /**
   * Action : Customer Account Logged Out Event
   * Event : Account Logged Out
   */
    jQuery(document).on('click', '[href="/account/logout"]', function() {
      localStorage.setItem('loggedIn', '');
      mixpanel.track('Account Logged Out', {
          'Section': 'Account Logged Out',
          "Customer Id": mixpanel_customer_data.id || null,
          "Customer Name": mixpanel_customer_data.name || null,
          "Customer Email": mixpanel_customer_data.email || null,
          "Customer Phone": mixpanel_customer_data.phone || null,
          "Customer Orders Count": mixpanel_customer_data.orders_count || null,
          "Customer First Name": mixpanel_customer_data.first_name || null,
          "Customer Last Name": mixpanel_customer_data.last_name || null
      });
      // console.log('Account Logged Out');
    });

  /**
   * Action : Product Add To Cart
   * Event : Item Added to Cart
   */
  // document.addEventListener('variant:add', function(e){
  //   const items = e['detail']['items'];
  //   items.forEach(function(item){
  //     mixpanel.track('Item Added to Cart', {
  //         'Product Name': item.product_title,
  //         'Product Price': (item.price / 100),
  //         'Section': 'Item Added to Cart'
  //     });
  //   });
  // });

  /**
   * Action : Cart Viewed
   * Event : Cart Viewed
   */
  jQuery(document).on('click', 'store-header a[aria-controls="cart-drawer"], .quick-buy-drawer__info .buy-buttons [href="/cart"]', () => triggerCartEvent('Cart Viewed'));

  /**
   * Action : Checkout_Cart
   * Event : Checkout_Cart
   */
  jQuery(document).on('click', 'cart-drawer #checkout2[lb-upsell-default-checkout-listener]', () => triggerCartEvent('Checkout_Cart'));

  /**
   * @method triggerCartEvents
   * @description For trigger cart event
  */
  function triggerCartEvent(event = null){
    if(!event) return;
    const productNamesArr = [];
    const productNames = jQuery("cart-drawer line-item .line-item__info a[href^='/products'] > span").each(function(){
      productNamesArr.push(jQuery(this).text().trim());
    });
    const cartItemCount = productNames.length;
    let totalPayValue = jQuery('cart-drawer [slot="footer"] .h-stack:nth-child(4) .money').text();
    totalPayValue = totalPayValue.replace(/Rs\. |,/g, '');

    mixpanel.track(event, {
        'Product Names': productNamesArr.join(', '),
        'Order Total': totalPayValue,
        'Total Items': cartItemCount,
        'Section': 'Cart Viewed'
    });
  }

  /**
   * Action : Item Wishlisted
   * Event : Item Wishlisted
   */
  document.addEventListener('wl:item:added',function(e){
    const product = e['detail']['product'];
    mixpanel.track('Item Wishlisted', {
        'Product Name': product.name,
        'Product ID': product.product_id,
        'Product Price': parseInt(product.price) / 100,
        'Section': 'Item Wishlisted'
    });
  });

  
  if (window.location.pathname === '/'){
    /**
     * Action : Home Page Viewed
     * Event : Home Page Viewed
     */
    mixpanel.track('Home Page Viewed', {
        'Session ID' : mixpanel.cookie.props.distinct_id,
        'User ID' : mixpanel_customer_data['id'] || "Nil"
    });

   /**
   * Action : Banner clicked on home page
   * Event : Banner clicked on home page
   */
    jQuery('main > section:nth-child(1)').click(function(){
      mixpanel.track('Banner clicked on home page', {
        'Banner Url' : jQuery(this).attr('href'),
        'Banner Slot No' : jQuery(this).index(),
        'Section': 'Home Banner Section'
      });
    });
    
   /**
   * Action : Footer App download click
   * Event : Footer App download click
   */
    jQuery('slideshow-carousel [href="https://blissclub.page.link/app"]').click(function(){
      mixpanel.track('Footer App download click', {
        'Footer App Link' : jQuery(this).attr('href'),
        'Section': 'Footer App download click'
      });
    });
    
   /**
   * Action : Banner Carousel Viewed
   * Event : Banner Carousel Viewed
   */
    // if (window.location.pathname === '/') {
      jQuery('.slideshow__controls .tap-area').click(function(){
        let getIndex = parseInt($(this).index() + 2);
        let link = $(this).parents('slideshow-carousel').find('.slideshow__slide:nth-child('+getIndex+')').attr('href');
        mixpanel.track('Banner Carousel Viewed', {
          'Banner Link' : link,
          'Section': 'Banner Carousel Viewed',
        });
      });
    // }

   /**
   * Action : Activity Clicked On Home Page
   * Event : Activity Clicked On Home Page
   */
    jQuery('image-link-blocks .image-link-blocks__item > a').click(function(e){
      const collection_url = jQuery(this).attr('href');
      const collection_url_arr = collection_url.split('/');
      const collection_handle = collection_url_arr[collection_url_arr.length - 1];
      let collection_name =  collection_handle.replace(/-/g, ' ').toUpperCase();
      mixpanel.track('Activity Clicked On Home Page', {
        'Activity Name' : collection_name,
        'Activity Handle' : collection_handle,
        'Activity Slot No' : jQuery(this).index(),
        'Activity Url' : collection_url,
        'Section': 'Activity List'
      });
    });

   /**
   * Action : Home page collection viewed
   * Event : Home page collection viewed
   */
    jQuery('collection-list > a.collection-card').click(function(e){
      const collection_url = jQuery(this).attr('href');
      const collection_url_arr = collection_url.split('/');
      const collection_handle = collection_url_arr[collection_url_arr.length - 1];
      let collection_name =  collection_handle.replace(/-/g, ' ').toUpperCase();
      mixpanel.track('Home page collection viewed', {
        'Collection Name' : collection_name,
        'Collection Handle' : collection_handle,
        'Collection Slot No' : jQuery(this).index(),
        'Collection Url' : collection_url,
        'Section': 'Collection List'
      });
    });
  }

  /**
 * Action : Category Page Viewed
 * Event : Category Page Viewed
 */
  if(category_path[window.location.pathname]){
    const category_name = category_path[window.location.pathname];
    mixpanel.track('Category viewed', {
      'Category Name' : category_name
    });
  }

   /**
   * Action : Checkout_sticky
   * Event : Checkout_sticky
   */
  jQuery(document).on('click', '.checkout-sticky-row #checkout2[lb-upsell-default-checkout-listener]', () => {
    mixpanel.track('Checkout_sticky', {
      'Section': 'Sticky Checkout'
    });
  });

   /**
   * Action : Checkout_ATC
   * Event : Checkout_ATC
   */
  jQuery(document).on('click', 'quick-buy-drawer .quick-buy-drawer__info #checkout2[lb-upsell-default-checkout-listener]', () => {
    mixpanel.track('Checkout_ATC', {
      'Section': 'Checkout ATC Clicked'
    });
  });
});

// For search mixpanel object
(function mx__panel(checkMixpanel){
  const mixp = checkMixpanel();
  if(mixp){
    document.dispatchEvent(new CustomEvent('bliss:mixpanel:activate'));
  }else{
    setTimeout(() => mx__panel(checkMixpanel), 100);
  }
})(function(){
  return (window.mixpanel && window.mixpanel.__loaded && window.mixpanel.__loaded === true) ? true : false;
});

/**
 * @method setMixpanelProps
 * @description For set the mixpanel properties
*/
function setMixpanelProps(){
  let mixpanel_project_token = '03654e7fe27edb06b3a94188bf3f08ab';
  const distinct_id = mixpanel.cookie.props.distinct_id;
  window.mixpanel['config']['token'] = mixpanel_project_token;
  window.mixpanel['config']['debug'] = true;
  mixpanel.identify(distinct_id);

  // Set User Data
  mixpanel.people.set({
    "Customer Id": mixpanel_customer_data['id'] || "Nil",
    "$name": mixpanel_customer_data['name'] || null, 
    "$email": mixpanel_customer_data['email'] || null,
    "Customer Name": mixpanel_customer_data['name'] || "Nil",
    "Customer Email": mixpanel_customer_data['email'] || "Nil",
    "Customer Phone": mixpanel_customer_data['phone'] || "Nil",
    "Customer Orders Count": mixpanel_customer_data['orders_count'] || "Nil",
    "Customer First Name": mixpanel_customer_data['first_name'] || "Nil",
    "Customer Last Name": mixpanel_customer_data['last_name'] || "Nil"
  });
}